// Import Bootstrap javascript
import "bootstrap";
// import 'bootstrap/js/dist/util'
// import 'bootstrap/js/dist/dropdown'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/collapse'
// import 'bootstrap/js/dist/modal'

// Import custom styles
import "../scss/licenciamiento_microsoft.scss";
import "../scss/consultenos.scss";

import "./sendform.js";

import "./offcanvas.js";
$('[data-toggle="tooltip"]').tooltip();

// Enabling HMR
if (module.hot) {
    module.hot.accept(console.log("Aceptando nuevos cambios..."));
}
